export default {
      id: "suicide-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#suicide",
      toString: function () {
        return this.url;
      }
    }